import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-edit-footer-logo',
  templateUrl: './edit-footer-logo.component.html',
  styleUrls: ['./edit-footer-logo.component.scss']
})
export class EditFooterLogoComponent implements OnInit, AfterViewInit {
  @Input() footerLogoData: any;
  footerLogoForm: FormGroup;
  fileImg64: any;
  wrongSize: any;
  srcData: SafeResourceUrl;

  // example
  img: any;
  img64: any;
  imgUpload = false;

  constructor(
    private fb: FormBuilder,
    private serviceModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngAfterViewInit(): void {
    this.updateForm();
  }

  private createForm(): any {
    this.footerLogoForm = this.fb.group({
      img: ['', Validators.required],
      img64: [''],
      img64Upload: [false],
      id: [0],
    });
  }

  private updateForm(): any {
    this.footerLogoForm.get('img').setValue(this.footerLogoData.img);
    this.footerLogoForm.get('id').setValue(this.footerLogoData.id);
    this.fileImg64 = this.footerLogoData.img;

    this.srcData = this.fileImg64;
  }

  sendData(): any {
    this.serviceModal.close(this.footerLogoForm.value);
  }


  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 200 && image.height <= 200) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.footerLogoForm.get('img').setValue((event.target.files[0]).name);
          this.footerLogoForm.get('img64').setValue(this.fileImg64.split(',')[1]);
          this.footerLogoForm.get('img64Upload').setValue(true);
          this.img = event.target.files[0].name;
          this.img64 = this.fileImg64.split(',')[1];
          this.srcData = this.fileImg64;
          this.imgUpload = true;
        } else {
          this.wrongSize = 'Resolución de imagen no permitida (requerida: 200px x 200px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

}
